import { useEffect, useState } from "react";
import { Portal } from "./pages/Portal.jsx";
import { Route } from "react-router-dom";
import { useAuth, AppRouter } from "@artprov/design-system";
import ErrorBoundary from "./pages/ErrorBoundary.jsx";
import { Loading } from "./common/components/Loading.jsx";


function App() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { keycloak } = useAuth();
  const user = keycloak?.tokenParsed;

  useEffect(() => {
    console.info("App.jsx - useEffect triggered. Current user:", user);
    if (!keycloak?.authenticated && user === null) {
      return;
    }
    if (user?.realm_access) {
      console.info(
        "App.jsx - User and realm_access available:",
        user.realm_access
      );
      const recursos = user.realm_access;
      const clientesDisponibles = Object.keys(recursos).filter(
        (cliente) => cliente !== "account"
      );
      setClientes(clientesDisponibles);
      setLoading(false);
    } else if (user) {
      console.warn(
        "App.jsx - User authenticated, but realm_access is undefined. Setting loading to false."
      );
      setLoading(false);
    } else if (user === null) {
      setLoading(false);
    }
  }, [user]);

  return (
    <div>
      <ErrorBoundary>
        <Loading show={loading} />
        <AppRouter>
          <Route path="/" element={<Portal show={!loading && !!clientes.length} user={user} />} />
        </AppRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
